var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(this.isCAPSLockOn),expression:"this.isCAPSLockOn"}],staticClass:"text-danger m-1 pull-right"},[_vm._v(_vm._s(_vm.translate('warnings.capsOpen')))])}
var staticRenderFns = []

export { render, staticRenderFns }